(function () {
  const initiatlize = () => {
    const elm = document.querySelector('share-button');
    const shareElements = {
      shareButton: elm.querySelector('button'),
      shareSummary: elm.querySelector('summary'),
      closeButton: elm.querySelector('.share-button__close'),
      successMessage: elm.querySelector('.share-button__message'),
      urlInput: elm.querySelector('input'),
      mainDetailsToggle: elm.querySelector('details'),
      buttonFallbackCopy: elm.querySelector('.share-button__copy')
    };

    const toggleDetails = () => {
      if (!shareElements.mainDetailsToggle.open) {
        shareElements.successMessage.classList.add('hidden');
        // shareElements.successMessage.textContent = '';
        shareElements.closeButton.classList.add('hidden');
        shareElements.shareSummary.focus();
      }
    };

    const copyToClipboard = () => {
      navigator.clipboard.writeText(shareElements.urlInput.value).then(() => {
        shareElements.successMessage.classList.remove('hidden');
        shareElements.successMessage.classList.add('flex');
        shareElements.closeButton.classList.remove('hidden');
        shareElements.urlInput.classList.add('hidden');
        shareElements.buttonFallbackCopy.classList.add('hidden');
        shareElements.closeButton.focus();
      });
    };

    const urlToShare = shareElements.urlInput
      ? shareElements.urlInput.value
      : document.location.href;

    if (navigator.share) {
      // safari
      shareElements.mainDetailsToggle.classList.add('hidden');
      shareElements.shareButton.classList.remove('hidden');
      shareElements.shareButton.addEventListener('click', () => {
        navigator.share({ url: urlToShare, title: document.title });
      });
    } else {
      // Chrome
      console.log('Not share api');
      shareElements.mainDetailsToggle.addEventListener(
        'toggle',
        toggleDetails()
      );
      shareElements.mainDetailsToggle
        .querySelector('.share-button__copy')
        .addEventListener('click', copyToClipboard);
      shareElements.closeButton.addEventListener('click', () => {
        shareElements.mainDetailsToggle.toggleAttribute('open');
      });
    }
  };

  if (window.document.readyState == 'complete') {
    initiatlize();
  } else {
    window.addEventListener('load', initiatlize);
  }
})();
